import { uploadData } from 'aws-amplify/storage';
import { fetchAuthSession } from 'aws-amplify/auth';
import { addFileToUploadedDocuments } from '../../graphqlCompnents/AWS/S3/addFileToUploadedDocuments';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { S3Client, CreateMultipartUploadCommand, UploadPartCommand, CompleteMultipartUploadCommand } from '@aws-sdk/client-s3';

const uploadLargeFile = async (file, bucket, key) => {
  try {
    // Fetch the current session and credentials
    const session = await fetchAuthSession();
    const credentials = session.credentials;

    console.log('  💋  credentials: ', credentials)
    if (!credentials) {
      throw new Error('No credentials found. User may not be authenticated.');
    }

    // Configure the S3 client with the credentials
    const s3Client = new S3Client({
      region: 'us-east-1', // Replace with your region
      credentials: {
        accessKeyId: credentials.accessKeyId,
        secretAccessKey: credentials.secretAccessKey,
        sessionToken: credentials.sessionToken,
      },
    });

    // Step 1: Initiate multipart upload
    const createUploadResponse = await s3Client.send(
      new CreateMultipartUploadCommand({
        Bucket: bucket,
        Key: key,
      })
    );
    const uploadId = createUploadResponse.UploadId;

    // Step 2: Upload parts
    const partSize = 5 * 1024 * 1024; // 5 MB per part
    const parts = [];
    let partNumber = 1;

    for (let start = 0; start < file.size; start += partSize) {
      const end = Math.min(start + partSize, file.size);
      const chunk = file.slice(start, end);

      const uploadPartResponse = await s3Client.send(
        new UploadPartCommand({
          Bucket: bucket,
          Key: key,
          PartNumber: partNumber,
          UploadId: uploadId,
          Body: chunk,
        })
      );

      parts.push({
        PartNumber: partNumber,
        ETag: uploadPartResponse.ETag,
      });

      partNumber++;
    }

    // Step 3: Complete multipart upload
    await s3Client.send(
      new CompleteMultipartUploadCommand({
        Bucket: bucket,
        Key: key,
        UploadId: uploadId,
        MultipartUpload: {
          Parts: parts,
        },
      })
    );

    console.log('Multipart upload completed successfully.');
  } catch (err) {
    console.error('Error uploading large file:', err);
    throw new Error(`Failed to upload large file: ${err.message}`);
  }
};

// const retryUploadData = async (uploadParams, retries = 3, delay = 1000) => {
//   for (let attempt = 1; attempt <= retries; attempt++) {
//     try {
//       // Try the upload
//       await uploadData(uploadParams);
//       console.log(`Upload successful on attempt ${attempt}`);
//       return; // Exit once successful
//     } catch (err) {
//       console.warn(`Upload failed on attempt ${attempt}:`, err);

//       const errorParams = {
//         bucket: 'failed on '+attempt,
//         identityId: err,
//         //protected/us-east-1:acfe627b-7f9c-c12b-46a1-8d65dc75169a/a1d3aec5-5890-4b9e-a32a-cab61307d46d.png
//         key: uploadParams?.path,
//       };
//       await addFileToUploadedDocuments(errorParams);

//       // If we've reached the max retries, throw the error
//       if (attempt === retries) {
//         console.error('Max retries reached. Upload failed.');
//         const errorParams = {
//           bucket: 'max attempts '+attempt,
//           identityId: err,
//           //protected/us-east-1:acfe627b-7f9c-c12b-46a1-8d65dc75169a/a1d3aec5-5890-4b9e-a32a-cab61307d46d.png
//           key: uploadParams?.path,
//         };
//         await addFileToUploadedDocuments(errorParams);
//         throw err;
//       }

//       // Wait before the next retry (exponential backoff)
//       const backoffTime = delay * Math.pow(2, attempt - 1); // Delay doubles each time
//       console.log(`Retrying in ${backoffTime}ms...`);
//       await new Promise((resolve) => setTimeout(resolve, backoffTime));
//     }
//   }
// };
const retryUploadData = async (uploadParams, retries = 5, delay = 2000) => {
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      await uploadDataWithTimeout(uploadParams, 60000); // Use the timeout wrapper
      console.log(`Upload successful on attempt ${attempt}`);
      return; // Exit once successful
    } catch (err) {
      console.warn(`Upload failed on attempt ${attempt}:`, err);

      if (attempt === retries) {
        console.error('Max retries reached. Upload failed.');
        throw new Error(`Upload failed after ${retries} attempts: ${err.message}`);
      }

      const backoffTime = delay * Math.pow(2, attempt - 1); // Exponential backoff
      console.log(`Retrying in ${backoffTime}ms...`);
      await new Promise((resolve) => setTimeout(resolve, backoffTime));
    }
  }
};

const uploadDataWithTimeout = async (uploadParams, timeout = 60000) => {
  return Promise.race([
    uploadData(uploadParams),
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error('Upload timed out')), timeout)
    )
  ]);
};

export const uploadFileToS3 = async (props) => {
  if (!props) {
    console.log('ERROR: No props sent.');
    return 'ERROR: No props';
  }

  try {
    const session = await fetchAuthSession();
    const identityId = session.identityId;
    const fileobj = props.file;
    const filename = props.filename||props.file.name;
    const extension = filename.split('.').pop().toLowerCase();
    const mimeType = props.filetype;
    const bucket = props.bucket;
    // const fileKey = 'protected/' + identityId + '/' + uuidv4() + '.' + extension;
    const encodedIdentityId = decodeURIComponent(identityId); // Manually encode the identityId
    const fileKey = `protected/${encodedIdentityId}/${uuidv4()}.${extension}`;

    const fileParams = {
      bucket: bucket,
      identityId: identityId,
      //protected/us-east-1:acfe627b-7f9c-c12b-46a1-8d65dc75169a/a1d3aec5-5890-4b9e-a32a-cab61307d46d.png
      key: fileKey,
    };

    const uploadedDocumentId = await addFileToUploadedDocuments(fileParams);

    // await retryUploadData({
    //   path: fileKey,
    //   data: fileobj,
    //   options: {
    //     contentType: mimeType,
    //     bucket: {
    //       bucketName: bucket,
    //       region: 'us-east-1',
    //     },
    //   },
    // }, 7, 1000); // 5 retries with an initial delay of 1 second

    const uploadParams = {
      path: fileKey,
      data: fileobj,
      options: {
        contentType: mimeType,
        bucket: {
          bucketName: bucket,
          region: 'us-east-1',
        },
      }
    }

    // await uploadData(uploadParams);
    console.log('  💋  uploadParams: ', uploadParams);
    await uploadLargeFile(fileobj, bucket, fileKey);

    const returnData = {
      fileName: fileKey,
      // fileName: filename,
      identityId: identityId,
      key: fileKey,
      documentId: uploadedDocumentId,
    };

    return returnData;
  } catch (err) {
    return err;
  }
};

uploadFileToS3.propTypes = {
  props: PropTypes.shape({
    file: PropTypes.object.isRequired,
    filename: PropTypes.string.isRequired,
    filetype: PropTypes.string.isRequired,
    bucket: PropTypes.string.isRequired,
  }).isRequired,
};